<main class="timeapp supplies">
	<form [formGroup]="supplyForm">
		<div>
			<div style="flex-direction: row; flex-wrap: nowrap; align-items: center;">
				<mat-form-field>
					<mat-label> {{ "MAIN_APP_TIME_PLUS.SUPPLY_ENTRY.articleNumber" | translate }}</mat-label>
					<input formControlName="articleNumber" matInput/>
				</mat-form-field>
				<mat-icon (click)="openProductSelect()" *ngIf="(isMobile | async)">inventory_2</mat-icon>
			</div>
			<mat-form-field>
				<mat-label> {{ "MAIN_APP_TIME_PLUS.SUPPLY_ENTRY.articleDescription"  | translate }}</mat-label>
				<input formControlName="articleDescription" matInput/>
			</mat-form-field>
		</div>
		<div>
			<mat-form-field>
				<mat-label> {{ "MAIN_APP_TIME_PLUS.SUPPLY_ENTRY.quantity"  | translate }}</mat-label>
				<input formControlName="quantity" matInput type="number" type="number"/>
			</mat-form-field>
			<mat-form-field>
				<mat-label> {{ "MAIN_APP_TIME_PLUS.SUPPLY_ENTRY.unit"  | translate }}</mat-label>
				<input formControlName="unit" matInput/>
			</mat-form-field>
		</div>
		<div>
			<mat-form-field>
				<mat-label> {{ "MAIN_APP_TIME_PLUS.SUPPLY_ENTRY.pricePerUnit" | translate }}</mat-label>
				<input formControlName="pricePerUnit" matInput type="number"/>
			</mat-form-field>
			<mat-form-field>
				<mat-label> {{ "MAIN_APP_TIME_PLUS.SUPPLY_ENTRY.priceTotal"  | translate }}</mat-label>
				<input formControlName="priceTotal" matInput/>
			</mat-form-field>
		</div>
		<div>
			<mat-form-field *ngIf="['m', 'm²', 'm³'].includes((calcMode | async)|| '')">
				<mat-label> {{ "MAIN_APP_TIME_PLUS.SUPPLY_ENTRY.length"  | translate }}</mat-label>
				<input formControlName="length" matInput type="number"/>
			</mat-form-field>
			<mat-form-field *ngIf="['m²', 'm³'].includes((calcMode | async)|| '')">
				<mat-label> {{ "MAIN_APP_TIME_PLUS.SUPPLY_ENTRY.width"  | translate }}</mat-label>
				<input formControlName="width" matInput type="number"/>
			</mat-form-field>
			<mat-form-field *ngIf="['m³'].includes((calcMode | async)|| '')">
				<mat-label> {{ "MAIN_APP_TIME_PLUS.SUPPLY_ENTRY.thiccness"  | translate }}</mat-label>
				<input formControlName="thickness" matInput type="number"/>
			</mat-form-field>
			<mat-form-field *ngIf="['m', 'm²', 'm³'].includes((calcMode | async)|| '')">
				<mat-label> {{ "MAIN_APP_TIME_PLUS.SUPPLY_ENTRY.amount"  | translate }} [{{ calcMode| async }}]</mat-label>
				<input formControlName="amount" matInput type="number"/>
			</mat-form-field>
		</div>
	</form>
	
	<ng-container *ngIf="!( isMobile | async )">
		<app-time-app-work-supply-product-list (productSelected)="setProduct($event)"></app-time-app-work-supply-product-list>
	</ng-container>
</main>

<footer class="timeapp documents">
	<a routerLink="../.." style="color: white;">
		<mat-icon class="">
			arrow_back
		</mat-icon>
	</a>
	<mat-icon (click)="saveEntry()" [ngClass]="{'disabled': !supplyForm.valid}" class="icon-size">save</mat-icon>
</footer>